import React from "react";

import "./GameDemo.css";

function GameDemo() {
  return (
    <div className="GameDemo">
      <h2>Demo</h2>
      <div>
        <img src="/images/demo.gif" alt="animated demo" />
      </div>
    </div>
  );
}

export default GameDemo;
